/**
 * @desc 列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.WarehouseRulesRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/warehouseRules/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
